webpackJsonp([162898551421021],{

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = function NotFoundPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'mw8 center db tc' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      'NOT FOUND'
	    ),
	    _react2.default.createElement('iframe', { src: 'https://giphy.com/embed/11VrJR0acdEe9a', width: '580', height: '280', frameBorder: '0', 'class': 'giphy-embed', allowFullScreen: true }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You just hit a route that doesn\'t exist... the sadness.'
	    )
	  );
	};
	
	exports.default = NotFoundPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-d8c7bb5f40f03c6c8fb4.js